import { Select } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import HmPageHeaderTitle from "../../unit/HmPageHeaderTitle";

const monthlyData = ({ ...props }) => {
  const cal_month_data = props.cal_month_data ? props.cal_month_data : {};
  const translation_main_category_data_total =
    props.translation_main_category_data_total;
  return <>waiting</>;
};

const FinancialConditionCashFlow = ({ ...props }) => {
  const { appId, data } = props;
  if (data == null || data == undefined) {
    return <></>;
  }
  const cal_month_data = data.cal_month_data ? data.cal_month_data : {};
  const translation_main_category_data_total =
    data.translation_main_category_data_total
      ? data.translation_main_category_data_total
      : "";
  const translation_main_category_data = data.translation_main_category_data;
  const translation_main_category_data_total_zhichu =
    data.translation_main_category_data_total_zhichu;
  const translation_main_category_data_zhichu =
    data.translation_main_category_data_zhichu;

  return (
    <>
      <Card sx={{ mb: "1em" }}>
        <CardContent>
          <HmPageHeaderTitle
            title={`Cash Flows To Date`}
            sx={{ mt: "0em", mb: "1em" }}
          />
          <Grid container>
            <Grid item xs={1}>
              <HeaderLabelTitle title="Account Name " />
            </Grid>
            <Grid item xs={2}>
              <Select
                id="cash_flow"
                native
                value={""}
                fullWidth
                //onChange={handleChange}
                size="small"
              >
                <option value={""}>Select</option>
                <option value={1}>Positive</option>
                <option value={2}>Negative</option>
              </Select>
            </Grid>
            <Grid item xs={1}>
              <Button
                size="small"
                sx={{ ml: 1, fontSize: "0.875rem" }}
                variant="contained"
              >
                Filter
              </Button>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <HeaderLabelTitle title="Monthly Cash Inflow And Outflow" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}></Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <HeaderLabelTitle title="Weekly Cash Inflow And Outflow" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}></Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default FinancialConditionCashFlow;
